<template>
  <div class="share-demo">
    <div v-show="sending" class="loading-overlay-circle">
      <i class="fa-light fa-circle-notch fa-spin"></i>
    </div>
    <transition name="first" v-if="!sent">
      <form @submit.prevent="shareLink()" :class="{ 'loading-overlay': sending }">
        <h3>{{$t('demo.share-modal.title')}}</h3>
        <p class="description text-small">
          {{$t('demo.share-modal.description')}}
        </p>
        <custom-input
          v-model="shareForm.userName"
          :name="'username'"
          :label="$t('demo.share-modal.name-label')"
          :placeholder="$t('demo.share-modal.name-placeholder')"
          focusInputField
        />
        <custom-input
          v-model="emails"
          :name="'email'"
          :label="$t('demo.share-modal.email-label')"
          :placeholder="$t('demo.share-modal.email-placeholder')"
          :invalidInput="showErrorMessage"
        />
        <p v-if="showErrorMessage" class="text-xs text-danger">{{$t('demo.share-modal.email-invalid')}}</p>
        <button type="submit" :disabled="!shareForm.userName || !emails" class="btn btn-primary">{{$t('demo.share-modal.send')}}</button>
      </form>
    </transition>
    <transition name="second" v-else>
      <div>
        <h3>Shared with your buddy!</h3>
        <p class="description text-small text-muted">This messages closes itself in: {{ timeToClose }}</p>
        <button type="submit" class="btn btn-secondary" @click="$emit('close')">Close</button>
      </div>
    </transition>
  </div>
</template>

<script>
import appHelper from "@/assets/js/appHelper.js";
export default {
  name: "ShareDemoModal",
  data() {
    return {
      shareForm: {
        userName: this.$store.state.demoData.metadata.user.userName,
        emails: []
      },
      emails: "",
      sending: false,
      sent: false,
      timeToClose: 3,
      showErrorMessage: false,
    };
  },
  methods: {
    shareLink() {
      this.showErrorMessage = false
      if(!this.valid){
        this.showErrorMessage = true
        return
      }

      this.shareForm.emails = this.emails.split(",").map((e) => {
        return e.trim();
      });
      this.sending = true;
      this.$store
        .dispatch("shareDemoLink", this.shareForm)
        .then((res) => {
          this.sending = false;
          this.sent = true;
          setInterval(() => {
            this.timeToClose = this.timeToClose - 1;
            if (this.timeToClose < 0) {
              this.$emit("close");
            }
          }, 1000);
        })
        .catch((e) => {
          console.log(e);
          this.sending = false;
        });
    }
  },
  computed: {
    emailArray() {
      return this.emails.length > 0
        ? this.emails.split(",").map((e) => {
            return e.trim();
          })
        : [];
    },
    invalidEmails() {
      return this.emailArray.filter((e) => {
        return appHelper.emailRegex.test(e) == false;
      });
    },
    
    valid() {
      return this.emails.length > 0 && !this.invalidEmails.length;
    }
    
  },
  watch: {
    emails: {
      handler: function(){
        if(this.showErrorMessage == true) this.showErrorMessage = false
      }
    }
  },
  mounted() {
    console.log(this.$store.state.demoData);
  }
};
</script>

<style lang="less">
.share-demo {
  transition: 0.2s;
  padding: 16px;
  .description {
    margin: 0;
  }
  .btn {
    margin-top: 12px;
  }

  .loading-overlay-circle {
    font-size: 14px !important;
    transform: translate(-50%, -50%) !important;
  }

  .first-enter-to .second-enter-to {
    position: absolute;
    opacity: 1;
    transform: translateX(0);
  }
  .first-enter,
  .first-leave-to {
    position: absolute;
    opacity: 0;
    transform: translateX(-100px);
  }

  .second-enter,
  .second-leave-to {
    position: absolute;
    opacity: 0;
    transform: translateX(100px);
  }
  .first-enter-active,
  .first-leave-active {
    transition: all 0.2s ease;
  }
  .second-leave-active,
  .second-enter-active {
    transition: all 0.2s ease;
    transition-delay: 0.1s;
  }
}
</style>
